import { SET_CLIENT_REFRESH_AUTH } from "@/store/modules/AuthClient/types";

export default [`AuthClient/${SET_CLIENT_REFRESH_AUTH}`];
